module.exports = require("core-js-pure/stable/weak-map");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js-stable/weak-map.js
// module id = 6384
// module chunks = 25